import { useSyncExternalStore } from "react";
import { birthdayProgress } from "./birthdayProgress";

export function ProgressStorageNotice() {
  const durable = useSyncExternalStore(birthdayProgress.subscribe, birthdayProgress.isDurable, () => true);
  if (durable) return null;
  return <p className="progress-storage-note" role="status">浏览器暂时不能保存进度。仍可以继续玩，离开或刷新前请留意：这次的花色可能无法保留。</p>;
}
